/**
 * Module dependencies.
 */

import {
  Accordion,
  Typography,
  accordionSummaryClasses,
  css,
} from '@mui/material';

import { Image as ImageComponent } from 'components/atoms/image/image';
import { color } from 'styles/utils/colors';
import { ifProp } from 'styled-tools';
import styled from '@emotion/styled';

/**
 * Export `Wrapper` styled component.
 */

export const Wrapper = styled.div<{
  isOpen: boolean;
}>`
  flex: 0.2;

  @media (max-width: 1200px) {
    background-color: ${color('primary200')};
    position: fixed;
    top: 0;
    left: 0;
    width: 280px;
    padding: 16px;
    z-index: 1000;
    bottom: 0;
    overflow-y: auto;
    transition: left 0.3s ease-in-out;

    ${ifProp(
      'isOpen',
      css`
        left: 0;
      `,
      css`
        left: -280px;
      `,
    )};
  }
`;

/**
 * Export `OpenCategoriesButton` styled component.
 */

export const OpenCategoriesButton = styled.div<{
  isOpen: boolean;
}>`
  background-color: ${color('primary200')};
  position: fixed;
  top: calc(30%);
  left: -100px;
  padding: 12px 32px;
  border-top-right-radius: 32px;
  border-top-left-radius: 32px;
  box-shadow: 2px -4px 10px rgba(0, 0, 0, 0.4);
  z-index: 1000;
  transition: left 0.3s ease-in-out;
  transform: rotate(-270deg);
  transform-origin: left bottom;
  display: none;

  ${ifProp(
    'isOpen',
    css`
      left: 274px;
    `,
    css`
      left: 0;
    `,
  )};

  @media (max-width: 1200px) {
    display: flex;
  }
`;

/**
 * Export `Image` styled component.
 */

export const Image = styled(ImageComponent)`
  grid-area: image;
  width: 100%;
`;

/**
 * Export `Label` styled component.
 */

export const Label = styled(Typography)`
  color: ${color('primary600')};
  font-weight: 500;
  font-size: 14px;
`;

/**
 * Export `ProductWrapper` styled component.
 */

export const ProductWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;

  &:hover ${Label} {
    color: ${color('primary800')};
    text-decoration: underline;
  }
`;

/**
 * Export `Thumb` styled component.
 */

export const Thumb = styled(ImageComponent)`
  grid-area: image;
  width: 36px;
  height: 36px;
  border-radius: 50px;
  overflow: hidden;
`;

/**
 * Export `StyledAccordion` styled component.
 */

export const StyledAccordion = styled(Accordion)`
  padding: 0;
  width: 280px;
  box-shadow: initial;

  & .${accordionSummaryClasses.content}, .${accordionSummaryClasses.expanded} {
    min-height: initial;
    margin: 0;
  }
`;
